import React from 'react';
import { Star, Users, Award, TrendingUp, ShieldCheck } from 'lucide-react';
const stats = [{
  icon: <Users className="w-5 h-5" data-id="element-243" />,
  value: '+1.000',
  label: 'Profesionales confían en el sistema'
}, {
  icon: <Star className="w-5 h-5" data-id="element-244" />,
  value: '4.9/5',
  label: 'Valoración promedio'
}, {
  icon: <TrendingUp className="w-5 h-5" data-id="element-245" />,
  value: '+275',
  label: 'Recursos clínicos y legales'
}, {
  icon: <Award className="w-5 h-5" data-id="element-246" />,
  value: '#1',
  label: 'Sistema elegido en Argentina'
}];
const logos = ['Consultorio Privado', 'Centros de Salud', 'Clínicas Podológicas', 'Atención Domiciliaria', 'Obras Sociales'];
export function SocialProofBar() {
  return <section className="relative bg-slate-900 text-white overflow-hidden" data-id="element-247">
      {/* Subtle gradient accent line at top */}
      <div className="h-1 bg-gradient-to-r from-[#0D7377] via-amber-500 to-[#0D7377]" data-id="element-248"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-249">
        {/* Headline */}
        <div className="text-center mb-6" data-id="element-250">
          <div className="inline-flex items-center gap-2 mb-3" data-id="element-251">
            <div className="flex -space-x-1" data-id="element-252">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-253" />)}
            </div>
            <span className="text-amber-400 font-bold text-sm ml-1" data-id="element-254">4.9/5</span>
          </div>
          <h3 className="text-2xl md:text-3xl font-black mb-2" data-id="element-255">
            Elegido por más de 1.000 podólogos en Argentina
          </h3>
          <p className="text-slate-400 text-sm max-w-xl mx-auto" data-id="element-256">
            El sistema de documentación clínica más completo y profesional del
            mercado
          </p>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-257">
          {stats.map((stat, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-3 text-center backdrop-blur-sm" data-id="element-258">
              <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#0D7377]/20 text-[#0D7377] mb-2" data-id="element-259">
                {stat.icon}
              </div>
              <p className="text-xl md:text-2xl font-black text-white mb-0.5" data-id="element-260">
                {stat.value}
              </p>
              <p className="text-xs text-slate-400 leading-tight" data-id="element-261">
                {stat.label}
              </p>
            </div>)}
        </div>

        {/* Trust strip */}
        <div className="flex flex-col items-center" data-id="element-262">
          <p className="text-xs text-slate-500 uppercase tracking-widest font-semibold mb-3" data-id="element-263">
            Utilizado en todo tipo de consultorios
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-264">
            {logos.map((name, i) => <div key={i} className="flex items-center gap-2 text-slate-400" data-id="element-265">
                <ShieldCheck className="w-4 h-4 text-[#0D7377]" data-id="element-266" />
                <span className="text-sm font-medium" data-id="element-267">{name}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}